<script type="text/babel">
import ManagesModalState from "dashboard-js/mixins/ManagesModalState";
import RestoreScrollOnPageBack from "dashboard-js/mixins/RestoreScrollOnPageBack";

export default {
  mixins: [ManagesModalState, RestoreScrollOnPageBack],

  props: ["courses", "platforms", "user"],

  data() {
    return {
      instructors: {}
    };
  },

  computed: {
    analytics() {
      return this.platforms[0];
    },

    instagram() {
      return this.platforms[1];
    },

    youtube() {
      return this.platforms[2];
    },

    betterhype() {
      return {
        slug: "betterhype",
      };
    },
  },

  created() {
    this.instructors = {
      miafriis: {
        name: "Mia Friis",
        profile_photo_url:
          "https://yt3.ggpht.com/a-/AN66SAzmI2djngo5QXjK07GzP32neXF02_Ttei2G7g=s200-mo-c-c0xffffffff-rj-k-no",
        channels: [
          {
            platform: this.instagram,
            resource_name: "miafriis",
            resource_url: "https://www.instagram.com/miafriis/",
          },
          {
            platform: this.youtube,
            resource_name: "Mia Friis",
            resource_url: "https://www.youtube.com/channel/UCXct0KXlAgkyFmgSeORbFxw",
          },
        ],
      },
      annearason: {
        name: "Anne Arason",
        profile_photo_url:
          "https://yt3.ggpht.com/a-/AN66SAwr5V9_YmK0B5dcbSvztPo6H54kuR_uxoiy-g=s200-mo-c-c0xffffffff-rj-k-no",
        channels: [
          {
            platform: this.analytics,
            resource_name: "annearason.dk",
            resource_url: "http://www.annearason.dk",
          },
          {
            platform: this.instagram,
            resource_name: "annearason",
            resource_url: "https://www.instagram.com/annearason/",
          },
          {
            platform: this.youtube,
            resource_name: "Anne Arason",
            resource_url: "https://www.youtube.com/user/annearason",
          },
        ],
      },
      isabellavlk: {
        name: "Isabella Vlk",
        profile_photo_url:
          "https://yt3.ggpht.com/a-/AN66SAw_2l52qzAkMQa_ZfhjNIG-qaPSsGszdPxu3g=s200-mo-c-c0xffffffff-rj-k-no",
        channels: [
          {
            platform: this.analytics,
            resource_name: "bellasmadunivers",
            resource_url: "https://nouw.com/bellasmadunivers",
          },
          {
            platform: this.instagram,
            resource_name: "isabellavlk",
            resource_url: "https://www.instagram.com/isabellavlk/",
          },
          {
            platform: this.youtube,
            resource_name: "Isabella Vlk",
            resource_url: "https://www.youtube.com/channel/UC3IqRJsJqBCH6SlkKeiMiEg",
          },
        ],
      },
      betterhype: {
        name: "betterhype",
        profile_photo_url:
          "https://lh3.googleusercontent.com/VGBeOek5fpfEDF-R5FJI2mt1568WsYsycl0OIG5Qci-Fiqf6IN-aW1qTPJIULY-tVn6MiTgsCECrcI0tvqzIR2vOPA=n-w200-h200",
        channels: [
          {
            platform: this.instagram,
            resource_name: "betterhypeapp",
            resource_url: "https://www.instagram.com/betterhypeapp/",
          },
          {
            platform: this.youtube,
            resource_name: "betterhype",
            resource_url: "https://www.youtube.com/channel/UC83LrvPFQIleMxE-dJDnVsw",
          },
        ],
      },
    };
  },

  methods: {
    becomeInstructor() {
      Bus.$emit("showSupportForm", {
        subject: "Anmodning om at blive instruktør på influentskolen",
        message:
          "Hej betterhype!\n" +
          "\n" +
          "Jeg er interesseret i at blive instruktør på jeres influentskole.\n" +
          "\n" +
          "Hvordan kan jeg blive det?\n" +
          "\n" +
          "Med venlig hilsen\n" +
          this.user.name,
      });
    }
  },
};
</script>
